import { Typography } from "@mui/material";
import { doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import React from "react";
import {
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { useSelector } from "react-redux";

export default function ModelLabel({ modelId, ...props }) {

  const modelsState = useSelector((state) => state.collections.models);

  if (!modelsState || modelsState.loading || !modelsState.idMap.hasOwnProperty(modelId)) {
    return null;
  }

  const model = modelsState.idMap[modelId];

  return (
    <Typography
      {...props}
    >
      {model.label}
    </Typography>
  );
}
